export default __webpack_public_path__ + "static/Schnittholz-4d609b5e9dfedb3158b3d34fb0f4f3a0.jpg";